// @ts-nocheck
import client from "../../utils/axios";
import { useQuery, queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import type { UserFindManyQueryResponse, UserFindManyQueryParams, UserFindMany401 } from "../models/UserFindMany";
import type { QueryObserverOptions, UseQueryResult, QueryKey, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";

 type UserFindManyClient = typeof client<UserFindManyQueryResponse, UserFindMany401, never>;
type UserFindMany = {
    data: UserFindManyQueryResponse;
    error: UserFindMany401;
    request: never;
    pathParams: never;
    queryParams: UserFindManyQueryParams;
    headerParams: never;
    response: UserFindManyQueryResponse;
    client: {
        parameters: Partial<Parameters<UserFindManyClient>[0]>;
        return: Awaited<ReturnType<UserFindManyClient>>;
    };
};
export const userFindManyQueryKey = (params?: UserFindMany["queryParams"]) => ["api", "v5", "users", ...(params ? [params] : [])] as const;
export type UserFindManyQueryKey = ReturnType<typeof userFindManyQueryKey>;
export function userFindManyQueryOptions(params?: UserFindMany["queryParams"], options: UserFindMany["client"]["parameters"] = {}) {
    const queryKey = userFindManyQueryKey(params);
    return queryOptions({
        queryKey,
        queryFn: async () => {
            const res = await client<UserFindMany["data"], UserFindMany["error"]>({
                method: "get",
                url: `/api/v5/users`,
                params,
                ...options
            });
            return res.data;
        },
    });
}
/**
 * @summary Find many UserEntity with query
 * @link /api/v5/users
 */
export function useUserFindMany<TData = UserFindMany["response"], TQueryData = UserFindMany["response"], TQueryKey extends QueryKey = UserFindManyQueryKey>(params?: UserFindMany["queryParams"], options: {
    query?: Partial<QueryObserverOptions<UserFindMany["response"], UserFindMany["error"], TData, TQueryData, TQueryKey>>;
    client?: UserFindMany["client"]["parameters"];
} = {}): UseQueryResult<TData, UserFindMany["error"]> & {
    queryKey: TQueryKey;
} {
    const { query: queryOptions, client: clientOptions = {} } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? userFindManyQueryKey(params);
    const query = useQuery({
        ...userFindManyQueryOptions(params, clientOptions) as unknown as QueryObserverOptions,
        queryKey,
        ...queryOptions as unknown as Omit<QueryObserverOptions, "queryKey">
    }) as UseQueryResult<TData, UserFindMany["error"]> & {
        queryKey: TQueryKey;
    };
    query.queryKey = queryKey as TQueryKey;
    return query;
}
export const userFindManySuspenseQueryKey = (params?: UserFindMany["queryParams"]) => ["api", "v5", "users", ...(params ? [params] : [])] as const;
export type UserFindManySuspenseQueryKey = ReturnType<typeof userFindManySuspenseQueryKey>;
export function userFindManySuspenseQueryOptions(params?: UserFindMany["queryParams"], options: UserFindMany["client"]["parameters"] = {}) {
    const queryKey = userFindManySuspenseQueryKey(params);
    return queryOptions({
        queryKey,
        queryFn: async () => {
            const res = await client<UserFindMany["data"], UserFindMany["error"]>({
                method: "get",
                url: `/api/v5/users`,
                params,
                ...options
            });
            return res.data;
        },
    });
}
/**
 * @summary Find many UserEntity with query
 * @link /api/v5/users
 */
export function useUserFindManySuspense<TData = UserFindMany["response"], TQueryKey extends QueryKey = UserFindManySuspenseQueryKey>(params?: UserFindMany["queryParams"], options: {
    query?: Partial<UseSuspenseQueryOptions<UserFindMany["response"], UserFindMany["error"], TData, TQueryKey>>;
    client?: UserFindMany["client"]["parameters"];
} = {}): UseSuspenseQueryResult<TData, UserFindMany["error"]> & {
    queryKey: TQueryKey;
} {
    const { query: queryOptions, client: clientOptions = {} } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? userFindManySuspenseQueryKey(params);
    const query = useSuspenseQuery({
        ...userFindManySuspenseQueryOptions(params, clientOptions) as unknown as QueryObserverOptions,
        queryKey,
        ...queryOptions as unknown as Omit<QueryObserverOptions, "queryKey">
    }) as UseSuspenseQueryResult<TData, UserFindMany["error"]> & {
        queryKey: TQueryKey;
    };
    query.queryKey = queryKey as TQueryKey;
    return query;
}